export default "__VITE_ASSET__kJnm8KpO__"